import React, { Component } from 'react';
import { connect } from 'react-redux';
import MetaTags from 'react-meta-tags';

import './Contact.scss';
import './Basic.scss';

import { addEvent } from '../../APIClient/events';
import { openIntercomChat } from '../../Helpers/chat_helpers';
import { isCreator, isBrand, isShopper } from '../../Helpers/user_helpers';

class Contact extends Component {
  componentDidMount() {
    addEvent('Contact Us - Page View');
  }

  render() {
    const { user } = this.props;

    let emailAddress = 'support@shopmy.us';
    if (!isCreator(user)) {
      emailAddress = 'creatorsupport@shopmy.us';
    } else if (isBrand(user)) {
      emailAddress = 'brandsupport@shopmy.us';
    } else if (isShopper(user)) {
      emailAddress = 'shoppersupport@shopmy.us';
    }

    return (
      <div className='contact-outer-container basic-outer-container'>
        <MetaTags>
          <title>Contact Us | ShopMy</title>
          <meta property='description' content='To get in touch with us, send an email to team@shopmy.us' />
        </MetaTags>
        <div className='basic-header-container narrow'>
          <div className='basic-header-title-badge-container'>
            <h1 className='basic-header-title-badge'>CONTACT</h1>
          </div>
          <h2 className='basic-header-body simple'>
            {isCreator(user) || isBrand(user) ? (
              <>
                Please access our{' '}
                <span
                  class='chat'
                  onClick={() => {
                    openIntercomChat();
                  }}
                >
                  live chat support
                </span>{' '}
                or email <span className='email'>{emailAddress}</span> for assistance.
              </>
            ) : (
              <>
                To get in touch with us, send an email to <span className='email'>{emailAddress}</span>.
              </>
            )}
          </h2>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  const { user } = state;
  return { user };
};

export default connect(mapStateToProps, {})(Contact);
